import React, { useState } from 'react'
import GroupOfButtons from '../../Molecules/GroupOfButtons/GroupOfButtons'
import { Form, Select } from "antd";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import './ManageProducts.scss'
import ProductTable from '../../Molecules/ProductTable/ProductTable';
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle';
const { Option } = Select;

const ManageProducts = () => {
  
  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
  });

  return (
    <div className="nd-grid manage-product">
      <HeaderTitle
        headerText="Gestionar productos"
      />
      <div className="mt-30 mb-20">
        <GroupOfButtons
          content={{
            first: "Activos",
            second: "Inactivos",
          }}
          formsHandler={formsHandler}
          setFormsHandler={setFormsHandler}
        />
      </div>

      <div className="box s-pxy-20 m-pxy-50">
        <p className="source-24 mb-20">Filtrar productos</p>
        <div className="manage-product__select">
          <InputFormContainer label="Por categoria:" indentificador="category" customClass="manage-product__select--item">
            <Form.Item
              name="category"
              rules={[{ required: true, message: "Categoria" }]}
            >
              <Select placeholder="Categoria" size="large">
                <Option value={"telecom"}>Telecom</Option>
              </Select>
            </Form.Item>
          </InputFormContainer>
          <InputFormContainer label="Por sub categoría:" indentificador="sub_category"  customClass="manage-product__select--item">
            <Form.Item
              name="sub_category"
              rules={[{ required: true, message: "Sub Category" }]}
            >
              <Select placeholder="Sub Categoría" size="large">
                <Option value={"servicios_de _internet"}>Servicios de internet</Option>
              </Select>
            </Form.Item>
          </InputFormContainer>
        </div>
         {
          formsHandler.showForm1 && <ProductTable />
         } 
         {
          formsHandler.showForm2 && <ProductTable inactives={true} />
         } 
      </div>
    </div>
  )
}

export default ManageProducts

